import React from 'react';
import { Link } from 'react-router-dom';

const LatestFeatures = () => {
  return (
    <div className="text-center mt-5 p-2">
      <div className="">
        <h2 className="section-title">Our Insights</h2>
      </div>
      <Link to="/ISOAIM">
        <button className="btn btn-primary px-4 py-2 rounded-pill shadow">
          Ensuring Trustworthy AI
        </button>
      </Link>
    </div>
  );
};

export default LatestFeatures;
